/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemDisplayPromoCodeWrapper_user$ref = any;
export type CartItemPromoCode_user$ref = any;
export type CartItemPromoCode_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": ItemDisplayPromoCodeWrapper_user$ref;
    readonly " $refType": CartItemPromoCode_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemPromoCode_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ItemDisplayPromoCodeWrapper_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bac8cd3f8a9db178fe62263e1496b76e';
export default node;
